// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"822":"a6ba2f54","990":"6d78ebf9"}[chunkId] + ".chunk.css";
};